// src/core/lib/api/sdk.ts — the shared @primate-intelligence/sdk client (PRI-439 R13)
//
// Design Part III §23 (C3): the web client consumes the SAME published SDK a
// customer gets. First-party auth = Clerk session JWTs resolved per-request
// via the token registry (§24 triple-accept: the public auth middleware takes
// Clerk JWTs, pv_ keys, and pvct_ tokens on one path).
//
// C1 measurement (§21): every SDK request carries `X-Primate-Client: web` so
// api_request_metrics can bucket product-plane traffic for the rolling-7-day
// dogfooding report.

import { Primate } from '@primate-intelligence/sdk/browser'
import { API_BASE_URL } from './base'
import { getAuthToken } from './token'

/** C1 client tag — server logs this into api_request_metrics.client. */
export const PRIMATE_CLIENT_TAG = 'web'

export const sdk = new Primate({
  baseUrl: API_BASE_URL,
  authToken: getAuthToken,
  defaultHeaders: { 'X-Primate-Client': PRIMATE_CLIENT_TAG },
})

export { PrimateError, PrimateTimeoutError } from '@primate-intelligence/sdk/browser'
export type {
  Analysis,
  AnalysisResult,
  Video,
  Stream,
  Clip,
} from '@primate-intelligence/sdk/browser'
